import React from 'react'
import { Stack, Typography } from '@mui/material'
import { formatRoundedUsdAmount } from '../../utils/rounding-formatting-utils'

interface RiskSummaryProps {
  equityRatio: Record<string, string>
}

const RiskSummary: React.FC<RiskSummaryProps> = ({ equityRatio }) => {
  return (
    <Stack gap={0} paddingX={1} maxWidth={400} width='100%'>
        <Stack direction='row' justifyContent='space-between'>
        <Typography>
            bybit ltv:
        </Typography>
        <Typography>
            {formatRoundedUsdAmount(equityRatio.BTC_exposure ?? '')}
        </Typography>
        </Stack>
        <Stack direction='row' justifyContent='space-between'>
        <Typography>
            okx ltv:
        </Typography>
        <Typography>
            {formatRoundedUsdAmount(equityRatio.ETH_exposure ?? '')}
        </Typography>
        </Stack>
        <Stack direction='row' justifyContent='space-between'>
        <Typography>
            gate ltv:
        </Typography>
        <Typography>
            {formatRoundedUsdAmount(equityRatio.GATE_LTV ?? '')}
        </Typography>
        </Stack>
    </Stack>
  )
}

export default RiskSummary
